// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","gridContainer":"Header_gridContainer__lNH1k"};